import React from 'react'
import PropTypes from 'prop-types'
import { Spinner } from '@telus/koodo-ui-kit'

export const SIZE = {
  SM: 'SM',
  LG: 'LG',
  MD: 'MD',
  MDS: 'MDS',
  SMW: 'SMW'
}

// UDS `Spinner` ships only two sizes (`large` and `small`). Map the legacy
// SIZE enum onto them so existing call sites keep rendering at roughly the
// same scale they had with the old custom CSS-border spinner.
const SIZE_VARIANT = {
  [SIZE.MD]: 'large',
  [SIZE.LG]: 'large',
  [SIZE.SM]: 'small',
  [SIZE.MDS]: 'small',
  [SIZE.SMW]: 'small'
}

const Loader = ({ loading = false, className = '', size = SIZE.MD }) => {
  if (!loading) return null
  return (
    <div data-testid="spinning-loader" className={className}>
      <Spinner
        show
        inline
        label=""
        variant={{ size: SIZE_VARIANT[size] }}
      />
    </div>
  )
}

Loader.propTypes = {
  loading: PropTypes.bool,
  size: PropTypes.oneOf([SIZE.SM, SIZE.LG, SIZE.MD, SIZE.MDS, SIZE.SMW]),
  className: PropTypes.string
}

export default Loader
